// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nr-0";